import { AuthPageStackProps } from './AuthPageStack.props';
import { AuthPageStackRoot } from './AuthPageStack.styles';

const AuthPageStack = ({ children }: AuthPageStackProps) => (
  <AuthPageStackRoot>{children}</AuthPageStackRoot>
);

export default AuthPageStack;
